import React from 'react'

function CustomCard({children,onClick}) {
  return (
    <div onClick={onClick} className='cardBody'>{children}</div>
  )
}

export default CustomCard